export default __webpack_public_path__ + "static/media/magento-badge.b6e18745.png";